export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const FORGOT_PASSWORD = '/forgot-password';

export const HOME = '/';
export const DASHBOARD = '/';

export const COMPONENTS = '/components';

export const USER = '/customer';
export const USER_DETAIL = '/customer/:id';

export const STAFF = '/staff';
export const STAFF_SET_PASSWORD = '/me/set-pass/:email/:otp';
export const BLOCK_EMAIL = '/block-email';

export const TEMPLATE = '/template';
export const CREATE_TEMPLATE = '/template/create';
export const VIEW_REPORT = '/template/view-report';

export const CODE_MANAGEMENT = '/code/management';
export const CODE_CREATION = '/code/create';

export const ALLOCATION = '/allocation';
export const EDIT_ALLOCATION = '/allocation/:id';

export const CAMPAIGN_MANAGEMENT = '/campaign-management';

export const PARTNER_PROGRAM = '/partner-program';
export const PROCESS_DIVIDEND_PAYOUTS = '/partner-program/dividend-payouts';
